module.exports = __webpack_public_path__ + "static/img/product3.9cc6184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3.jpg
// module id = ZusE
// module chunks = 0